import { InputHTMLAttributes, forwardRef, useId } from "react";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, className = "", ...props }, ref) => {
    const generatedId = useId();
    const inputId = props.id ?? generatedId;
    const errorId = error ? `${inputId}-error` : undefined;
    const describedBy = [props["aria-describedby"], errorId].filter(Boolean).join(" ") || undefined;

    return (
      <div className={className}>
        {label && <label className="label-base" htmlFor={inputId}>{label}</label>}
        <input
          ref={ref}
          className="input-base"
          {...props}
          id={inputId}
          aria-describedby={describedBy}
          aria-invalid={props["aria-invalid"] ?? Boolean(error)}
        />
        {error && <p id={errorId} className="mt-1 text-xs text-danger">{error}</p>}
      </div>
    );
  }
);
Input.displayName = "Input";
